
<b-container style="margin-top: 70px">
  <b-row>
    <b-col sm="12" md="12" lg="8" xl="8">
      <configure-accessory-dialog :template-version="template_version"
                                  :quote-product="quote_product"
                                  :attributes-list="dialogAttributesList"
                                  :prices-list="dialogPricesList">
      </configure-accessory-dialog>
    </b-col>
    <b-col sm="12" md="12" lg="4" xl="4">
      <div class="position-sticky" style="top:70px">
        <configure-accessory-summary :template-version="template_version"
                                     :quote-product="quote_product"
                                     :price-name="summaryPriceName">
        </configure-accessory-summary>
        <configuration-dialog-buttons :quote-product="quote_product" :is-public="isPublic"></configuration-dialog-buttons>
      </div>
    </b-col>
  </b-row>
</b-container>
